let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cCo7G")).then(() => parcelRequire('gCM0C'));